<script>
import Menu from '/src/components/header.vue';
import Rodape from '/src/components/rodape.vue';
import Parte5 from '/src/components/parte5.vue';

export default {
    name: 'Clientes',
    components:{
        Menu,
        Rodape,
        Parte5
    }
}
</script>

<template>
    <Menu></Menu>
    <div class="clientes">
        <Parte5></Parte5>
    </div>
    <Rodape></Rodape>
</template>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Staatliches&display=swap');

@media (max-width: 900px) {
.clientes {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #ffffff;
    width: 100vw;
    padding: 2rem;
    min-height: 53.5vh;
}
.menu {
  position: relative;
  width: 100%;
  z-index: 1;
}
.rodape {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
}
}
@media (min-width: 721px) {
.clientes {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #ffffff;
    width: 100vw;
    padding: 2rem;
    min-height: 53.5vh;
}
.menu {
  position: relative;
  width: 100%;
  z-index: 1;
}
.rodape {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
}
}
</style>